import { AdsTargetingProvider } from '@folklore/ads';

import Ad, { AdProps } from '../ads/Ad';

interface AdCardProps extends AdProps {
    cardType?: string | null;
    cardTheme?: CardTheme | LegacyCardTheme | null;
    cardSize?: CardSize | null;
    cardRatio?: CardRatio | null;
}

function AdCard({ cardType, cardTheme, cardSize, cardRatio, ...props }: AdCardProps) {
    const targeting = {
        cardType: cardType || 'vertical',
        cardTheme,
        cardSize,
        cardRatio,
        inCard: true,
    };
    return (
        <AdsTargetingProvider targeting={targeting}>
            <Ad {...props} />
        </AdsTargetingProvider>
    );
}

export default AdCard;
